module.exports = __webpack_public_path__ + "media/images/3dLessonGray-a07bafab7b8d63caa614ec403fa1cf55.svg";